const SIZE = 10

export const SERVICE_ORDERS_STATUS_FILTER_OPTIONS = [
  {
    id: 'download',
    text: 'serviceOrdersList.filter.download'
  },
  {
    id: 'canceled',
    text: 'serviceOrdersList.filter.canceled'
  }
]

export const SERVICE_ORDERS_FILTER = {
  queryString: { size: SIZE },
  filterOptions: [
    {
      name: 'serviceOrdersList.filter.request-number',
      type: 'number',
      name_query: 'id'
    },
    {
      name: 'serviceOrdersList.filter.order-status',
      type: 'select',
      name_query: 'status',
      select_options: SERVICE_ORDERS_STATUS_FILTER_OPTIONS
    }
  ]
}

export const TERMINALS_FILTER = {
  queryString: { size: SIZE },
  filterOptions: [
    {
      name: 'terminalList.filter.serial-number',
      type: 'text',
      name_query: 'serialNumber'
    },
    {
      name: 'terminalList.filter.nickname',
      type: 'text',
      name_query: 'nickname'
    },
    {
      name: 'terminalList.filter.store',
      type: 'text',
      name_query: 'store'
    }
  ]
}
